import type { FC } from 'react';

interface Props {
    maskedCardNumber: string;
    cardBrand?: string;
}

export const CardNumberView: FC<Props> = ({ maskedCardNumber, cardBrand }) => (
    <>
        {maskedCardNumber} {cardBrand || ''}
    </>
);
